export default "__VITE_ASSET__KtEbZ_Ff__"